import { Line } from 'react-chartjs-2'

import {
  CategoryScale,
  Chart as ChartJS,
  ChartOptions,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip
} from 'chart.js'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend)

import { ServiceSummaryItem, ServiceSummaryKey } from '@/common/api/params/analytics'

const SERVICE_COLOR: Record<ServiceSummaryKey, string> = {
  data_integration: '#0EA5E9',
  reco_media: '#4F46E5',
  article_upload: '#10B981',
  geo_llmo: '#F59E0B',
  review: '#EF4444',
  ai_purchase_assist: '#8B5CF6',
  carte: '#EC4899',
  persona: '#14B8A6',
  mail_reco: '#6366F1'
}

const opts: ChartOptions<'line'> = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: { mode: 'index', intersect: false },
  plugins: {
    legend: {
      display: true,
      position: 'top',
      align: 'end',
      labels: { color: '#34414F', font: { size: 12 }, padding: 8, usePointStyle: true }
    },
    tooltip: {
      backgroundColor: 'rgba(2, 6, 23, 0.95)',
      titleFont: { size: 11, weight: 'bold' },
      bodyFont: { size: 11 },
      padding: 8,
      cornerRadius: 4
    }
  },
  scales: {
    x: {
      grid: { display: false },
      border: { display: false },
      ticks: {
        font: { size: 10 },
        color: '#64748B',
        maxRotation: 0,
        autoSkip: true,
        maxTicksLimit: 8
      }
    },
    y: {
      beginAtZero: true,
      border: { display: false },
      grid: { color: '#E4E8EE' },
      ticks: { font: { size: 10 }, color: '#64748B' }
    }
  },
  elements: {
    line: { borderWidth: 2, tension: 0.35 },
    point: { radius: 0, hoverRadius: 4 }
  }
}

const formatDateLabel = (iso: string): string => {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return `${d.getMonth() + 1}/${d.getDate()}`
}

interface Props {
  services: ServiceSummaryItem[]
}

const ServiceTrendChart = ({ services }: Props) => {
  // ラベルは最初のサービスの日付列（全サービス同じ30日分）
  const labels = (services[0]?.daily_counts ?? []).map((d) => formatDateLabel(d.date))

  // 0件しかないサービスは凡例から外す（ノイズ削減）
  const visibleServices = services.filter((s) => s.count_30d > 0)

  return (
    <div className='h-[280px] w-full'>
      <Line
        data={{
          labels,
          datasets: visibleServices.map((s) => ({
            label: s.name,
            data: s.daily_counts.map((d) => d.count),
            borderColor: SERVICE_COLOR[s.key] || '#64748B',
            backgroundColor: 'transparent',
            fill: false
          }))
        }}
        options={opts}
      />
    </div>
  )
}

export default ServiceTrendChart
